module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-10-Classes-Active-62ee635eeb95e1a519d67455362ee6f8.png";